<template>
    <div class="setting-wrap">
        <h2>비밀번호 변경</h2>
        <p>
            8~32자의 영문 대문자, 소문자, 숫자, 특수문자를 조합하여 비밀번호를 사용하실 수 있습니다.<br />
            개인정보 보호를 위해 6개월마다 주기적으로 비밀번호를 변경해 사용하는 것이 안전합니다.
        </p>
        <p class="notice">※ 여러 사이트에 동일한 비밀번호를 사용하면 도용되기 쉬우므로 비밀번호를 주기적으로 변경해 주는 것이 안전합니다.</p>
        <div class="user-list-wrap">
            <ul class="user-list">
                <li class="clearfix">
                    <label for="user-pw">비밀번호</label>
                    <input type="text" name="user-pw" id="user-pw" v-model="pass">
                </li>
                <li class="clearfix">
                    <label for="user-pw-new">새 비밀번호</label>
                    <input type="password" name="user-pw-new" id="user-pw-new" v-model="new_pass">
                </li>
                <li class="clearfix">
                    <label for="user-pw-new2">새 비밀번호 확인</label>
                    <input type="password" name="user-pw-new2" id="user-pw-new2" v-model="new_pass_re">
                </li>
            </ul>
        </div>
        <p class="pw-btn"><button type="button" @click="chage_pass">확인</button></p>
        <!--<br /><br /><br /><br /><br /><br /><br /><br />-->
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { STATUS_CODE } from '@/lib/constants'
  export default {
    name: 'password',
    data() {
      return {
        pass: '',
        new_pass: '',
        new_pass_re: ''
      }
    },
    computed: {
      ...mapState(['account'])
    },
    methods: {
      async chage_pass () {
        let post_data = {dr_id: this.account.pharm_id, pass: this.pass, new_pass: this.new_pass, new_pass_re: this.new_pass_re}
        let {data} = await this.axios.post('auth/dr/change_pass/pharm', post_data)
        if (data.status != STATUS_CODE.OK) return alert(data.msg)

        alert('비밀번호 변경이 완료되었습니다.')
      },
    }
  }
</script>

<style scoped>
    .setting-wrap {
        width: 100%;
        padding: 30px;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
        height: 520px;
    }

    .setting-wrap > h2 {
        margin-bottom: 15px;
        font: 400 18px 'Noto Sans KR', sans-serif;
    }

    .setting-wrap > p {
        color: #b2b2b2;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .setting-wrap > .notice {
        color: #ff2a69;
        margin-bottom: 50px;
    }

    .user-list > li {
        height: 50px;
        margin-bottom: 10px;
    }

    .user-list > li:last-child {
        margin-bottom: none;
    }

    .user-list > li label,
    .user-list > li input {
        float: left;
    }

    .user-list > li label {
        width: 150px;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    .user-list > li input {
        width: 400px;
        height: 50px;
        padding: 0;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
    }

    .pw-btn {
        width: 120px;
        height: 50px;
        margin: 30px 0 0 150px;
        background-color: #746ce6;
    }

    .pw-btn button {
        color: #fff;
        width: 100%;
        height: 100%;
        border: none;
        text-align: center;
        background-color: transparent;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }
</style>